export const getHeaderTitle = (state) => {
    return state.header_title;
}